export default __webpack_public_path__ + "static/media/coworker-7.ca28790e.svg";